module.exports = __webpack_public_path__ + "static/offer-1-353f18693822545e801c87007763e4f1.png";